import React from 'react';
import styled from 'styled-components';

const List = styled.div`
  @media (max-width: ${props => props.theme.twoColToOneColLayout}px) {
    &.news-item-active {
      display: none;
    }
  }
`;

export default List;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/news/components/List.tsx